export enum PlatformType {
    INSTAGRAM = 'Instagram',
    TIKTOK = 'TikTok',
    YOUTUBE = 'YouTube'
}

export enum LibraryFilterType {
    ALL_REELS = 'ALL REELS',
    BY_CATEGORY = 'BY CATEGORY',
    BY_COLLECTION = 'BY COLLECTION',
    ORPHANS = 'СИРОТКИ'
}

export enum TemplatesListType {
    ONLY_TEMPLATES = 'ONLY_TEMPLATES',
    TEMPLATES_IN_CATEGORY = 'TEMPLATES_IN_CATEGORY',
    TEMPLATES_IN_COLLECTION = 'TEMPLATES_IN_COLLECTION'
}

export enum DetailsModeType {
    EDIT = 'EDIT',
    ADD = 'ADD'
}

export enum StatusPublishFeed {
    PUBLISHING = 'PUBLISHING',
    PUBLISHED = 'PUBLISHED',
}

export const reservedCategoriesIds = ['from_our_ads','free', 'most_popular', 'best_for_recaps', 'hot_trends', 'new', 'universal_templates', 'memories', 'collections'];

export interface ForceLogoutParams {
    version: number,
}

export enum OrderIndex {
    ASC = 'ASC',
      DESC = 'DESC'
}

export interface OrderOptions {
     orderBy: string,
     orderIndex: OrderIndex
}

export enum FilesStorageType {
  AWS = 'AWS',
  DIGITAL_OCEAN = 'DIGITAL_OCEAN'
}
